export const styles = theme => ({
    search: {
        "& input": {
            padding: "14px 14px",
        },
        marginRight: "1rem",
    },
    sectionInput: {
        minWidth: "200px",
        margin: "1rem 0",
        "& Button": {
            display: "block",
            width: "100%",
            padding: ".24706rem .42353rem",
            minHeight: "2.88235rem",
            textTransform: "none",
            fontWeight: "bold",
        },
    },

    inputField: {
        margin: "0.5rem 0"
    },
});
